import React from 'react'
import { ScreenContentQAQCHistoryBase } from 'modules/reports/screens/screen-qaqc/content/ScreenContentQAQCHistoryBase'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'

/**
 */
export function ScreenContentQAQCIonicBalanceHistory(): JSX.Element {
    return (
        <ScreenContentQAQCHistoryBase
            title={'Histórico de Balanço Iônico'}
            type={QAQCExecutionTypeEnum.IONIC_BALANCE}
            infoTitle={'Parâmetros Necessários'}
            infoContent={
                <>
                    <p>
                        Para o <strong>cálculo do balanço iônico (CBE)</strong> é necessário que a amostra (ou seja, um ponto em uma
                        data específica) apresente concomitantemente resultados para os parâmetros listados abaixo.
                        Caso contrário, não será possível realizar o cálculo.
                    </p>
                    <ul>
                        <li>Cálcio Dissolvido;</li>
                        <li>Magnésio Dissolvido;</li>
                        <li>Sódio Dissolvido;</li>
                        <li>Potássio Dissolvido;</li>
                        <li>Alcalinidade Total;</li>
                        <li>Cloreto Total;</li>
                        <li>Nitrato;</li>
                        <li>Sulfato Total.</li>
                    </ul>
                    <p>
                        O CBE é realizado através da equação a seguir. Somente as amostras cujo -10,00% &lt; CBE
                        &lt; 10,00% são aprovadas.
                    </p>
                    <p style={{ textAlign: 'center' }}>
                        <strong>CBE(%) = ((ΣCat - ΣAn) / (ΣCat + ΣAn)) * 100</strong>
                    </p>
                </>
            }
        />
    )
}
